import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationItems, NotificationState } from './notification.model';

export const selectNotificationState =
  createFeatureSelector<NotificationState>('notification');

export const isLoadingStateSelector = createSelector(
  selectNotificationState,
  (state: NotificationState): boolean => state.isLoading
);

export const isLoadedStateSelector = createSelector(
  selectNotificationState,
  (state: NotificationState): boolean => state.isLoaded
);

export const listStateSelector = createSelector(
  selectNotificationState,
  (state: NotificationState): NotificationItems => state.items
);

export const notificationCountSelector = createSelector(
  selectNotificationState,
  (state: NotificationState): number =>
    state.items.approval_pending.length +
    state.items.submission_pending.length +
    state.items.validation_pending.length
);
